import { render, staticRenderFns } from "./BulkAction.vue?vue&type=template&id=6bb4275a&scoped=true&"
import script from "./BulkAction.vue?vue&type=script&lang=js&"
export * from "./BulkAction.vue?vue&type=script&lang=js&"
import style0 from "./BulkAction.vue?vue&type=style&index=0&id=6bb4275a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4275a",
  null
  
)

export default component.exports